// WPGraphQL returns menuItems.nodes as a flat list that includes child items,
// so top-level items must be filtered on parentId and nested via childItems.

const byOrder = (a, b) => (a?.order ?? 0) - (b?.order ?? 0)

export const getMenu = (data, key) => {
  const nodes = data?.[key]?.nodes?.[0]?.menuItems?.nodes

  if (!nodes?.length) return []

  return nodes
    .filter((item) => !item.parentId)
    .sort(byOrder)
    .map((item) => ({
      ...item,
      childItems: [...(item.childItems?.nodes ?? [])].sort(byOrder),
    }))
}

// Mobile shows a single flat list, so parents and their children are merged.
// Deduped on path because a parent and its first child often point at the
// same page in the WP menu structure.
export const flattenMenus = (...menus) => {
  const seen = new Set()

  return menus.flat().reduce((acc, item) => {
    ;[item, ...(item.childItems ?? [])].forEach((entry) => {
      if (!entry?.path || seen.has(entry.path)) return
      seen.add(entry.path)
      acc.push(entry)
    })
    return acc
  }, [])
}
